import { useSearchParams } from 'next/navigation'

import { LOCALE } from '@/legacy-src/constants/locale.constants'

export const APP_STORE_ID = 'id6451498329'

const useAppLinks = () => {
  const searchParams = useSearchParams()

  const utmSource = searchParams?.get('utm_source') ?? 'web'
  const utmMedium = searchParams?.get('utm_medium') ?? 'link'
  const utmCampaign = searchParams?.get('utm_campaign') ?? 'web_app_url'

  return {
    appLinkApple: `https://apps.apple.com/${process.env.NEXT_PUBLIC_COUNTRY_IDENTIFIER}/app/hedepy/${APP_STORE_ID}?utm_source=${utmSource}&utm_medium=${utmMedium}&utm_campaign=${utmCampaign}`,
    appLinkGoogle: `https://play.google.com/store/apps/details?id=com.hedepy.hedepy&hl=${LOCALE}&utm_source=${utmSource}&utm_medium=${utmMedium}&utm_campaign=${utmCampaign}`,
  }
}

export default useAppLinks
